"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
// https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
exports.AcDropdownToggle = react_1.default.forwardRef(function (props, ref) {
    var onClick = props.onClick, className = props.className, children = props.children;
    var handleClick = function (e) {
        e.preventDefault();
        if (onClick) {
            onClick(e);
        }
    };
    return (react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "link", className: "text-secondary " + className, 
        // @ts-ignore
        ref: ref, onClick: handleClick }, children));
});
exports.AcDropdownToggle.displayName = 'AcDropdownToggle';
//# sourceMappingURL=AcDropdownToggle.js.map